import { useLocation } from "react-router-dom";
import DesktopNav from "./headerDesktop.component";
import MobileNav from "./headerMobile.component";

const Header = () => {
  const pathname = useLocation();

  return (
    <header className="w-full flex justify-center fixed top-4 left-0 z-50 pointer-events-none font-mont">
      <div className="w-[95vw] max-w-6xl bg-white/90 shadow-xl rounded-3xl border border-sky/30 backdrop-blur-lg px-4 sm:px-10 py-1 pointer-events-auto">
        <div className="hidden lg:block">
          <DesktopNav pathname={pathname} />
        </div>
        <div className="lg:hidden">
          <MobileNav pathname={pathname} />
        </div>
      </div>
    </header>
  );
};

export default Header;
